import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import {Card, Divider, List, ListItem, Link} from '@mui/material';
import PageBreadcrumbs from '../../../components/PageBreadcrumbs';

const JobPostings = (): JSX.Element => {

  const bulletListStyle = {
    listStyleType: "disc",
    pl: 3,
    "& li": {
      display: "list-item",
      //textIndent: "-0.5em", // tighten bullet spacing
      paddingBottom: 0,
      marginBottom: 0,
    },
    "& li::marker": {
      fontSize: "1.5em",  // adjust bullet size
    },
  };

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
            variant="h5"
            align={'left'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            gutterBottom
            marginBottom={2}
            >
            Career Opportunities
        </Typography>
        <Divider/>
        {
          <Grid container marginTop={3}>
            <Grid
              padding={3}
              size={12}
              component={Card}
              boxShadow={1}
              >
                <Typography variant='subtitle1'>There are no job openings at this time. Please check back later. </Typography>
            </Grid>
        </Grid>
        }
        {/* Quick links to each posting
        <Typography variant="subtitle1" fontWeight={700} marginTop={3}>
          Open Positions
        </Typography>
        <List dense sx={bulletListStyle}>
          <ListItem>
            <Link href="#auditor-analyst">Auditor/Analyst</Link>
          </ListItem>
          <ListItem>
            <Link href="#legal-counsel">Legal Counsel</Link>
          </ListItem>
        </List> */}
        {/* Auditor/Analyst */}
        {
          false &&
          <Grid container marginTop={3}>
            <Grid
              id="auditor-analyst"
              padding={3}
              size={12}
              component={Card}
              boxShadow={1}
              >

              {/* Title */}
              <Typography variant="h5" fontWeight={700}>
                Auditor/Analyst
              </Typography>
              <Typography variant="h6" gutterBottom fontWeight={700}>
                Office of Campaign and Political Finance
              </Typography>

              {/* Description */}
              <Typography variant='body1' marginTop={3}>
                The Office of Campaign and Political Finance (OCPF) is seeking a motivated individual to serve
                as Auditor/Analyst. This is a unique opportunity to work at the intersection of law, government,
                and public policy while helping to promote transparency, accountability, and public confidence
                in Massachusetts elections. OCPF administers the Massachusetts Campaign Finance Law
                (M.G.L. c. 55) through a balanced approach of education, guidance, and enforcement.
              </Typography>

              {/* Duties */}
              <Typography variant="subtitle1" gutterBottom marginTop={3} fontWeight={700} sx={{ textDecoration: 'underline' }}>
                Duties
              </Typography>
              <Typography variant="body1" gutterBottom>
                Primary duties include performing audits, analysis, and reconciliation of reports filed by
                candidates and political committees; assisting candidates and agents of committees in
                understanding the law and regulations; communicating with committees to answer questions and
                provide instruction/assistance on electronic filing system; discuss analysis prepared from audit
                reviews and investigations with senior staff to resolve compliance issues; assists in compliance
                review special projects. Provides significant support in the preparation of legal case reviews.
              </Typography>

              {/* Abilities */}
              <Typography variant="subtitle1" gutterBottom marginTop={3} fontWeight={700} sx={{ textDecoration: 'underline' }}>
                Abilities
              </Typography>
              <List dense sx={bulletListStyle}>
                <ListItem>
                  Ability to understand and apply statutes and regulations governing campaign finance.
                </ListItem>
                <ListItem>
                  Excellent communication skills (written and verbal) to assist committees in understanding the campaign finance law.
                </ListItem>
                <ListItem>
                  Ability to work within a team environment, as well as independently, and with a wide variety of stakeholders.
                </ListItem>
                <ListItem>
                  Willingness to work in a collaborative setting to achieve department objectives and provide regulatory guidance.
                </ListItem>
                <ListItem>
                  Demonstrate initiative, creativity and ability to share new ideas to improve processes and procedure.
                </ListItem>
                <ListItem>
                  Aptitude for databases and reporting and tracking tools; strong organizational skills, attention to detail and accuracy; strong analytical and problem-solving skills; ability to interpret and respond to questions in accordance with laws, regulations, and policies; ability to proactively set priorities and multi-task without compromising attention to detail; ability to preserve confidential information required.
                </ListItem>
                <ListItem>
                  Advanced knowledge in MS Word, Excel and Outlook preferred.
                </ListItem>
              </List>

              {/* Qualifications */}
              <Typography variant="subtitle1" gutterBottom marginTop={3} fontWeight={700} sx={{ textDecoration: 'underline' }}>
                Qualifications
              </Typography>
              <List dense sx={bulletListStyle}>
                <ListItem>
                  BA/BS in accounting, auditing, business administration, finance, public administration, political science, or government, or equivalent professional experience in related field.
                </ListItem>
                <ListItem>
                  Professional experience in a government, financial, banking, accounting or legal setting preferred but not required.
                </ListItem>
              </List>

              {/* Compensation */}
              <Typography variant="subtitle1" gutterBottom marginTop={3} fontWeight={700} sx={{ textDecoration: 'underline' }}>
                Compensation
              </Typography>
              <Typography variant='body1' gutterBottom>
                This is a full-time, exempt position with an excellent state employee benefits package. Starting
                salary will range from $70,000 to $80,000 depending on qualifications and experience. Currently
                a hybrid position based in Boston. Posting will remain open until position filled.
              </Typography>

              {/* Contact */}
              <Typography variant="body1" gutterBottom marginTop={2}>
                Please submit resume to{" "}
                <Link href="mailto:brittany.manning@mass.gov">
                  brittany.manning@mass.gov
                </Link>{'.'}
              </Typography>

              <Typography variant="body1" gutterBottom marginTop={2}>
                The Office of Campaign and Political Finance is an Equal Opportunity Employer and encourages applicants from a broad spectrum of backgrounds to apply for the position.
              </Typography>

              {/* Posting details */}
              <Typography variant="subtitle1" gutterBottom marginTop={3} fontWeight={700} sx={{ textDecoration: 'underline' }}>
                Posting Details
              </Typography>
              <Typography variant="body2"><strong>Official Title:</strong> Auditor/Analyst</Typography>
              <Typography variant="body2"><strong>Primary Location:</strong> United States-Massachusetts-Boston-1 Ashburton Place</Typography>
              <Typography variant="body2"><strong>Job:</strong> Campaign Finance Auditing</Typography>
              <Typography variant="body2"><strong>Agency:</strong> Office of Campaign and Political Finance</Typography>
              <Typography variant="body2"><strong>Schedule:</strong> Full-time</Typography>
              <Typography variant="body2"><strong>Shift:</strong> Day</Typography>
              <Typography variant="body2"><strong>Number of Openings:</strong> 1</Typography>
              <Typography variant="body2" gutterBottom><strong>Salary:</strong> $70,000 to $80,000</Typography>

              <Typography variant="body2" color="text.secondary" marginTop={2}>
                If you have Diversity, Affirmative Action or Equal Opportunity questions or need a reasonable
                accommodation, please contact Diversity/ADA Coordinator Brittany Manning &ndash; (617) 979-8300.
              </Typography>

            </Grid>
          </Grid>
        }
        {/* Legal Counsel Posting */}
        {
          false &&
          <Grid container marginTop={4}>
            <Grid
              id="legal-counsel"
              padding={3}
              size={12}
              component={Card}
              boxShadow={1}
              >

              {/* Title */}
              <Typography variant="h5" fontWeight={700}>
                Legal Counsel
              </Typography>
              <Typography variant="h6" gutterBottom fontWeight={700}>
                Office of Campaign and Political Finance
              </Typography>

              {/* Description */}
              <Typography variant='body1' marginTop={3}>
                The Office of Campaign and Political Finance (OCPF) is seeking a motivated attorney to serve
                as Legal Counsel. This is a unique opportunity to work at the intersection of law, government,
                and public policy while helping to promote transparency, accountability, and public confidence
                in Massachusetts elections. OCPF administers the Massachusetts Campaign Finance Law
                (M.G.L. c. 55) through a balanced approach of education, guidance, and enforcement.
              </Typography>

              {/* Duties */}
              <Typography variant="subtitle1" gutterBottom marginTop={3} fontWeight={700} sx={{ textDecoration: 'underline' }}>
                Duties
              </Typography>
              <Typography variant="body1" gutterBottom>
                Primary duties include initial review of case investigations, document gathering and review,
                interviewing witnesses, and recommending resolutions; conducting legal research; writing
                analyses, legal memoranda, and advisory opinions; presenting legal advice and policy
                recommendations; communicating with and providing guidance regarding the campaign finance
                law and regulations to candidates, committees, public officials, and the general public; assisting
                in drafting agency regulations, guidelines and policy; advising agency staff on legal matters; and
                other duties as assigned by the Director and General Counsel.
              </Typography>

              {/* Qualifications */}
              <Typography variant="subtitle1" gutterBottom marginTop={3} fontWeight={700} sx={{ textDecoration: 'underline' }}>
                Qualifications
              </Typography>
              <List dense sx={bulletListStyle}>
                <ListItem>
                  JD degree and active member in good standing admitted to the Massachusetts Bar.
                </ListItem>
                <ListItem>
                  At least 2 to 5 years of full-time or equivalent part-time related professional experience.
                </ListItem>
                <ListItem>
                  Ability to understand and apply statutes and regulations governing campaign finance.
                </ListItem>
                <ListItem>
                  Ability to use computer to conduct research, manage databases, and produce written documents.
                </ListItem>
                <ListItem>
                  Ability to lead or work with cross-functional teams and manage multiple projects.
                </ListItem>
                <ListItem>
                  Excellent communication skills (written and verbal) to assist candidates, committees, public officials, and the general public in understanding the campaign finance law.
                </ListItem>
                <ListItem>
                  Ability to work within a team environment, as well as independently. Willingness to work in a collaborative setting to achieve agency objectives and provide regulatory guidance.
                </ListItem>
                <ListItem>
                  Strong organizational skills, attention to detail and accuracy; strong analytical and problem-solving skills; ability to interpret and respond to questions in accordance with laws, regulations, and policies; ability to proactively set priorities and multi-task without compromising attention to detail; ability to exercise discretion and sound judgment; ability to preserve confidential information is required.
                </ListItem>
                <ListItem>
                  Advanced knowledge in MS Word, Excel and Outlook. Ability to learn new software systems.
                </ListItem>
              </List>

              {/* Compensation */}
              <Typography variant="subtitle1" gutterBottom marginTop={3} fontWeight={700} sx={{ textDecoration: 'underline' }}>
                Compensation
              </Typography>
              <Typography variant='body1' gutterBottom>
                This is a full-time, exempt, at-will position with an excellent state employee benefits package.
                Starting salary will range from $85,000 to $95,000 depending on qualifications and experience.
              </Typography>

              {/* Contact */}
              <Typography variant="body1" gutterBottom marginTop={2}>
                Interested applicants should submit a letter of interest and resume to Brittany Manning at{" "}
                <Link href="mailto:brittany.manning@mass.gov">
                  brittany.manning@mass.gov
                </Link>{'.'} This posting will remain open until the position is filled.
              </Typography>

              <Typography variant="body1" gutterBottom marginTop={2}>
                The Office of Campaign and Political Finance is an Equal Opportunity Employer and encourages applicants from a broad spectrum of backgrounds to apply for the position.
              </Typography>

              {/* Posting details */}
              <Typography variant="subtitle1" gutterBottom marginTop={3} fontWeight={700} sx={{ textDecoration: 'underline' }}>
                Posting Details
              </Typography>
              <Typography variant="body2"><strong>Official Title:</strong> Legal Counsel</Typography>
              <Typography variant="body2"><strong>Primary Location:</strong> United States-Massachusetts-Boston-1 Ashburton Place</Typography>
              <Typography variant="body2"><strong>Job:</strong> Legal Services</Typography>
              <Typography variant="body2"><strong>Agency:</strong> Office of Campaign and Political Finance</Typography>
              <Typography variant="body2"><strong>Schedule:</strong> Full-time, fixed hybrid</Typography>
              <Typography variant="body2"><strong>Shift:</strong> Day</Typography>
              <Typography variant="body2"><strong>Number of Openings:</strong> 1</Typography>
              <Typography variant="body2" gutterBottom><strong>Salary:</strong> $85,000 to $95,000</Typography>

              <Typography variant="body2" color="text.secondary" marginTop={2}>
                If you have Diversity, Affirmative Action or Equal Opportunity questions or need a reasonable
                accommodation, please contact Diversity/ADA Coordinator Brittany Manning &ndash; (617) 979-8300.
              </Typography>

            </Grid>
          </Grid>
        }

      </Container>
    </Main>
  );
};

export default JobPostings;